<template>
  <div>
    <a-form-model ref="form" :model="form.data" :rules="form.rules">
      <a-form-model-item label="标题" prop="name">
        <a-input v-model="form.data.name"/>
      </a-form-model-item>
      <a-form-model-item label="标题英文" prop="nameEn">
        <a-input v-model="form.data.nameEn"/>
      </a-form-model-item>
      <a-form-model-item label="主题">
        <a-select style="width: 100%;" v-model="form.data.topicId" allowClear>
          <a-select-option :key="item.id" :value="item.id" v-for="item in topic.data">
            {{ item.name }}
          </a-select-option>
        </a-select>
      </a-form-model-item>
<!--      <a-form-model-item label="主题"  prop="topicId">-->
<!--        <a-input v-model="form.data.topicId"/>-->
<!--      </a-form-model-item>-->
      <a-form-model-item label="封面图片(690*850))" prop="coverPath">
        <div class="a-input">
          <simple-uploader v-model="form.data.coverPath"/>
        </div>
      </a-form-model-item>
      <a-form-model-item>
        <a-button type="primary" v-if="!lookBookId" @click="onAdd">创建</a-button>
        <a-button type="primary" v-if="lookBookId" @click="onUpdate">更新</a-button>
        <a-button @click="onCancel">取消</a-button>
      </a-form-model-item>
    </a-form-model>
  </div>
</template>

<script>
import {
  _queryLookBook,
  _addLookBook,
  _updateLookBook,
} from '@/api/lookBookApi';
import {
  _queryLookBookTopics,
} from '@/api/lookBookTopicApi';
import SimpleUploader from '@/components/SimpleUploader.vue';

async function getLookBook() {
  const result = await _queryLookBook(this.lookBookId);
  if (result) {
    this.form.data.name = result.name;
    this.form.data.nameEn = result.nameEn;
    this.form.data.coverPath = result.coverPath;
    this.form.data.description = result.description;
    this.form.data.topicId = result.topicId;
  }
}

async function onAdd() {
  this.$refs.form.validate(async (valid) => {
    if (valid) {
      const result = await _addLookBook({
        name: this.form.data.name,
        nameEn: this.form.data.nameEn,
        coverPath: this.form.data.coverPath,
        description: this.form.data.description,
        topicId: this.form.data.topicId,

      });
      if (result) {
        if (this.onSubmitHandler) {
          this.$message.success('添加成功');
          this.onSubmitHandler();
        }
      }
    }
  });
}

function reviewVideo() {
  if (this.form.data.videoPath) {
    this.video.visible = true;
  }
}

async function onUpdate() {
  this.$refs.form.validate(async (valid) => {
    if (valid) {
      const result = await _updateLookBook(this.lookBookId, {
        name: this.form.data.name,
        nameEn: this.form.data.nameEn,
        coverPath: this.form.data.coverPath,
        subName: this.form.subName,
        topicId: this.form.data.topicId,
      });
      if (result) {
        if (this.onSubmitHandler) {
          this.$message.success('更新成功');
          this.onSubmitHandler();
        }
      }
    }
  });
}

function onCancel() {
  if (this.onCancelHandler) {
    this.onCancelHandler();
  }
}

export default {
  name: 'LookBookEdit',
  components: {
    // DictSelect,
    SimpleUploader,
  },
  props: {
    lookBookId: String,
    onSubmitHandler: Function,
    onCancelHandler: Function,
  },
  watch: {
    lookBookId() {
      if (this.lookBookId) {
        this.getLookBook();
      }
    },
  },
  methods: {
    onAdd,
    onUpdate,
    onCancel,
    getLookBook,
    reviewVideo,
  },
  data() {
    return {
      topic: {
        data: [],
      },
      video: {
        visible: false,
        url: '',
      },
      form: {
        data: {
          name: '',
          subName: '',
          coverPath: '',
          topicId: '',
          nameEn: '',
        },
        rules: {
          name: [{ required: true, trigger: 'blur' }],
          subName: [{ required: true, trigger: 'blur' }],
          coverPath: [{ required: true, trigger: 'blur' }],
          topicId: [{ required: true, trigger: 'blur' }],
          nameEn: [{ required: true, trigger: 'blur' }],
        },
        title: '',
      },
    };
  },
  async created() {
    const result = await _queryLookBookTopics({});
    console.log(result);
    this.topic.data = result.content;
    if (this.lookBookId) {
      await this.getLookBook();
    }
  },
};
</script>
